<template>
<div class="card-item borrowing"
  :id="item.itemId">
  <div class="card-item-heading"
    v-if="item.heading">{{ item.heading }}</div>
  <div class="card-item-content">
    <div v-for="(borrower, index) in item.data.borrowers"
      :index="index">
      <div class="input-item">
        <label for="">借入先名</label>
        <Input placeholder="○○銀行○○支店"
          v-model="borrower.name" />
      </div>
      <div class="input-item">
        <label for="">用途</label>
        <Input placeholder="自動車ローン"
          v-model="borrower.howUse" />
      </div>
      <div class="flex mt-harf">
        <div class="input-item">
          <label for="">残高</label>
          <Input placeholder="000"
            class="borrowing-amount"
            v-model.number="borrower.amount" /><span>万円</span>
        </div>
        <div class="input-item">
          <label for="">年間返済額</label>
          <Input placeholder="000"
            class="borrowing-amount"
            v-model.number="borrower.repaymentAtYear" /><span>万円</span>
        </div>
      </div>
      <div class="delete-item">
        <Button @click="destroyBorrower(index)"
          shape="circle"
          icon="ios-trash-outline"></Button>
      </div>
    </div>
    <div class="add-item">
      <Button shape="circle"
        icon="md-add"
        @click="addBorrower"></Button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['item', 'groupIndex', 'itemIndex'],
  computed: {},
  mounted: function () {},
  methods: {
    addBorrower: function () {
      this.$eventHub.$emit(
        'addItem',
        this.groupIndex,
        this.itemIndex,
        'borrowers'
      )
    },
    destroyBorrower: function (index) {
      this.$eventHub.$emit(
        'destroyItem',
        this.groupIndex,
        this.itemIndex,
        'borrowers',
        index
      )
    }
  }
}
</script>
